<template>
  <div
    class="cma-field-row"
    :class="{ 'cma-field-row--stacked': stacked }"
  >
    <span class="cma-field-row__label">{{ label }}</span>
    <span
      class="cma-field-row__value"
      :class="[
        { 'cma-field-row__value--highlighted': highlighted },
        status ? `cma-field-row__value--${status}` : null,
      ]"
    >{{ displayValue }}</span>
  </div>
</template>

<script>
export default {
  name: 'CmaFieldRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    unit: {
      type: String,
      default: '',
    },
    highlighted: {
      type: Boolean,
      default: true,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: null,
      validator: value => value === null || ['attention', 'critical'].includes(value),
    },
  },
  computed: {
    displayValue() {
      if (!this.unit) return `${this.value}`;
      return this.unit === '%' ? `${this.value}${this.unit}` : `${this.value} ${this.unit}`;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.cma-field-row
  display: flex
  justify-content: space-between
  align-items: baseline
  gap: 0.4rem
  padding: 0.25rem 0

  &--stacked
    flex-direction: row
    align-items: end
    gap: 0.1rem

  &__label
    color: var(--font-color-primary)
    font-size: 0.90rem
    font-weight: 600
    white-space: nowrap

    &::after
      content: ':'

    +media-min-3xl()
      font-size: 1.10rem

    +media-min-4xl()
      font-size: 1.30rem

  &__value
    color: var(--font-color-primary)
    font-weight: 600
    font-size: 0.90rem
    letter-spacing: 0.025em
    white-space: nowrap

    +media-min-3xl()
      font-size: 1.10rem

    +media-min-4xl()
      font-size: 1.30rem

    &--highlighted
      color: var(--font-color-primary)

    &--attention
      color: var(--color-warning)

    &--critical
      color: var(--color-danger)
</style>
